<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center align-items-top" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col  text-right  " >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>پیشخوان   </template>
                </m-h5><m-user-form-fills-1 v-bind='{...{},...{}}' :style='""' class="" ></m-user-form-fills-1></template>
                </m-div></template>
                </m-div></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUserFormFills1 from '@moeinmdn/miw-alpha-components/src/package/FormFill/UserFormFill/UserFormFills1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mDiv,mH5,mUserFormFills1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
